export enum SystemsEnum {
    cloud = 'cloud',
    comms = 'comms',
    distribution = 'distribution',
    hardware = 'hardware',
}
